import { Dropdown, IconButton, Icons, TextInput } from '@silverfort/sf-components';
import React, { FC } from 'react';
import { InsuranceRules } from '../../api/types/InsuranceRules';
import { CustomControl } from '../../api/types/InsuranceReport';

interface Props {
    setCustomControls: React.Dispatch<React.SetStateAction<CustomControl[]>>;
    customControl: CustomControl;
    index: number;
    insuranceRules: InsuranceRules;
}

const CustomControlItem: FC<Props> = ({ setCustomControls, customControl, index, insuranceRules }) => {
    const onNameChange = (newName: string) => {
        setCustomControls((prevState) => {
            const newControls = [...prevState];
            newControls[index].name = newName;
            return newControls;
        });
    };

    const onPolicyChange = (newPolicyData: CustomControl) => {
        setCustomControls((prevState) => {
            const newControls = [...prevState];
            newControls[index].policies = newPolicyData.policies;
            return newControls;
        });
    };

    const onDelete = () => {
        setCustomControls((prevState) => {
            const newControls = [...prevState];
            newControls.splice(index, 1);
            return newControls;
        });
    };

    return (
        <div className="w-full h-fit pr-[8px] flex items-center justify-between">
            <div className="h-full flex items-center gap-[8px]">
                <TextInput
                    placeholder="Name shown on the report"
                    onChange={onNameChange}
                    value={customControl.name}
                    className="h-[32px]"
                />
                <Dropdown
                    variant="trigger"
                    items={insuranceRules.options?.map((rule) => ({ value: rule.name, title: rule.name }))}
                    selectedItems={customControl.policies}
                    onChange={(value) =>
                        onPolicyChange({
                            name: customControl.name,
                            selected: true,
                            policies: (value as string[]) ?? null
                        })
                    }
                    multiple
                    size="small"
                    text="Select policy"
                />
            </div>
            <IconButton icon={Icons.Delete} onClick={onDelete} iconSize={20} iconClassName="text-sf-gray-400" />
        </div>
    );
};

export default CustomControlItem;
